var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.locationsLoaded)?_c('locations-map',{attrs:{"locations":_vm.locations,"disableDefaultUI":true,"zoomLevel":7,"scaleControl":false,"zoomControl":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }